import React from "react";


const darkenColor = (color, percentage) => {
  // Remove the # if present
  const hex = color.replace('#', '');
  
  // Convert hex to RGB
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  
  // Calculate darker RGB values
  const darkenAmount = percentage / 100;
  const newR = Math.max(0, Math.floor(r * (1 - darkenAmount)));
  const newG = Math.max(0, Math.floor(g * (1 - darkenAmount)));
  const newB = Math.max(0, Math.floor(b * (1 - darkenAmount)));
  
  // Convert back to hex
  const toHex = (n) => {
    const hex = n.toString(16);
    return hex.length === 1 ? '0' + hex : hex;
  };
  
  return `#${toHex(newR)}${toHex(newG)}${toHex(newB)}`;
};

const FileIcon = ({ color = '#D99F00', size = 20 }) => {
  const baseColor = color;

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M3.33333 2.5C3.33333 1.57953 4.07953 0.833333 5 0.833333H11.6667L16.6667 5.83333V17.5C16.6667 18.4205 15.9205 19.1667 15 19.1667H5C4.07953 19.1667 3.33333 18.4205 3.33333 17.5V2.5Z" 
        fill={baseColor}
      />
      <path 
        d="M11.6667 0.833333L16.6667 5.83333H12.5C12.0398 5.83333 11.6667 5.46024 11.6667 5V0.833333Z" 
        fill={darkenColor(baseColor, 20)}
      />
    </svg>
  );
};

export default FileIcon; 